import { RemuneracaoMedica } from '@/types/core'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'

@Module({ namespaced: true, name: 'RecalcularProcedimentosStore' })
export default class RecalcularProcedimentosStore extends VuexModule {
  public pagina: number = 1
  public qtdPorPagina: number = 50
  public mesAnoCompetencia: string = ''
  public itemRecalcularProcedimento: any = {}
  public fontePagadoraId: string = ''
  public descarteId: string = ''
  public fontePagadoras: any[] = []
  public itemsRecalcularProcedimentos: any[] = []
  public totalItems: number = 0
  remuneracaoMedica: RemuneracaoMedica.IPrestadorRecebimento = new RemuneracaoMedica.PrestadorRecebimento()

  @Mutation
  setMesAnoCompetencia(value: string) {
    this.mesAnoCompetencia = value
  }

  @Mutation
  setDescarteId(value: string) {
    this.descarteId = value
  }

  @Mutation
  setFontePagadoraId(value: string) {
    this.fontePagadoraId = value
  }

  @Mutation
  setQtdPorPagina(value: number) {
    this.qtdPorPagina = value
  }

  @Mutation
  setPagina(value: number) {
    this.pagina = value
  }

  @Mutation
  setFontePagadora(value: any[]) {
    this.fontePagadoras = value
  }

  @Mutation
  setTotalItems(value: number) {
    this.totalItems = value
  }

  @Mutation
  setItemsRecalcularProcedimentos(value: any[]) {
    this.itemsRecalcularProcedimentos = value
  }

  @Mutation
  clearMesAnoCompetencia() {
    this.mesAnoCompetencia = ''
  }

  @Mutation
  clearFontePagadoraId() {
    this.fontePagadoraId = ''
  }

  @Mutation
  setItemRecalcularProcedimento(value: any) {
    this.itemRecalcularProcedimento = value
  }

  @Action
  async enfileirarRecalculo() {
    try {
      const params: any = this.itemRecalcularProcedimento
      const atributos = [
        {
          nome: 'GeracaoRepasseId',
          valor: params.geracaoRepasseId,
        },
        {
          nome: 'MedicoProducaoProcedimentoId',
          valor: params.medicoProducaoProcedimentoId,
        },
      ]

      const body = {
        usarServiceBusCalculo: true,
        tipo: 'CriarProcedimentosPorGeracaoRepasse',
        atributos,
      }

      const response = await this.remuneracaoMedica.enfileirar(body)
      this.context.commit('setDescarteId', response.data.id)

      return await this.context.dispatch('getRecalculoRepasse')
    } catch (error) {
      return { success: false, message: 'Não foi possível realizar esta ação.', statusCode: 500 }
    }
  }


  @Action
  async getRecalculoRepasse() {
    const maxAttempts = 20
    let attempts = 0

    while (attempts < maxAttempts) {
      try {
        const params = {
          id: this.descarteId,
        }

        /* eslint-disable no-await-in-loop */
        const response = await this.remuneracaoMedica.getRecalculoRepasse(params)

        if (response.data.emProcessamento === false) {
          return response
        }
        // NÃO REMOVER - PARA DEBUG DO HOSPITAL
        console.log(`O processo ainda está em andamento. Tentativa ${attempts + 1}`)

        /* eslint-disable no-await-in-loop */
        await this.context.dispatch('delay', 15000)
      } catch (error) {
        console.error(`Tentativa ${attempts + 1} falhou: ${error}`)
      }

      attempts += 1
    }

    console.error('Excedido o número máximo de tentativas. Ação não concluída.')
    return { success: false, message: 'Não foi possível realizar esta ação.', statusCode: 500 }
  }

  @Action
  delay(ms: any) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

  @Action
  async getFontePagadoraAll() {
    try {
      const response = await this.remuneracaoMedica.getFontePagadoraAll()
      if (response.success) {
        this.context.commit('setFontePagadora', response.data)
      }
      return response
    } catch (error) {
      return { success: false, message: error }
    }
  }

  @Action
  async getAllProcedimentosRecalculo() {
    try {
      const params = {
        mesAnoCompetencia: this.mesAnoCompetencia ? `${this.mesAnoCompetencia}-01` : '',
        fontePagadoraId: this.fontePagadoraId,
        pagina: this.pagina,
        qtdPorPagina: this.qtdPorPagina,
      }
      const response = await this.remuneracaoMedica.getAllProcedimentosRecalculo(params)
      if (response.success) {
        this.context.commit('setItemsRecalcularProcedimentos', response.data.itens)
        this.context.commit('setTotalItems', response.data.totalRegistros)
      }
      return response
    } catch (error) {
      this.context.commit('setItemsRecalcularProcedimentos', [])
      return { success: false, message: error }
    }
  }
}
